export default {
  title_1: "常见问题".toUpperCase(),
  title_2: "深入了解 FraudVision".toUpperCase(),
  important: "重要通知".toUpperCase(),
  all_answers: "所有答案都在这里".toUpperCase(),
  text: "Get all the answers you need about Vision right here. We’re breaking it down for you.".toUpperCase(),
}
